import { MessageCircle, Phone } from "lucide-react";
import { telLink, waLink } from "../../lib/constants";

export default function FloatingWhatsApp() {
  return (
    <>
      <div
        data-testid="floating-cta"
        className="hidden md:flex fixed bottom-6 right-6 z-40 flex-col gap-3"
      >
        <a
          href={telLink}
          data-testid="floating-call"
          aria-label="Call Justudy Library"
          className="group inline-flex items-center justify-center w-14 h-14 bg-[#FACC15] hover:bg-[#EAB308] text-[#0F0F0F] rounded-full shadow-2xl shadow-[#FACC15]/30 transition-all hover:-translate-y-1"
        >
          <Phone className="w-5 h-5" />
        </a>
        <a
          href={waLink()}
          target="_blank"
          rel="noreferrer"
          data-testid="floating-whatsapp"
          aria-label="Chat on WhatsApp"
          className="relative inline-flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#1EBE5C] text-white rounded-full shadow-2xl shadow-[#25D366]/30 transition-all hover:-translate-y-1"
        >
          <span className="pulse-ring absolute inset-0 rounded-full" />
          <MessageCircle className="w-5 h-5 relative" />
        </a>
      </div>

      <div
        data-testid="mobile-cta-bar"
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t border-white/10 bg-[#0F0F0F]/95 backdrop-blur"
      >
        <a
          href={telLink}
          data-testid="mobile-call"
          className="inline-flex items-center justify-center gap-2 bg-[#FACC15] text-[#0F0F0F] font-semibold py-3.5 text-sm"
        >
          <Phone className="w-4 h-4" /> Call Now
        </a>
        <a
          href={waLink()}
          target="_blank"
          rel="noreferrer"
          data-testid="mobile-whatsapp"
          className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-semibold py-3.5 text-sm"
        >
          <MessageCircle className="w-4 h-4" /> WhatsApp
        </a>
      </div>
    </>
  );
}
